import { FC, useEffect } from 'react';
import { setStorage } from '@lhb/cache';
// import styles from './entry.module.less';
import Siteselectionmapb from '../siteselectionmapb/entry';

const Youth: FC<any> = () => {
  useEffect(() => {
    setStorage('IS_SHARE__HAS_TOEKN', true);
  }, []);

  return (
    <Siteselectionmapb/>
  );
};

export default Youth;
